import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { useEncumbrancesTable } from '../context/EncumbrancesTableContext';

const EncumbrancesTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useEncumbrancesTable();

  const hasCoOwnersColumn = Boolean(actions.handleToggleRowExpansion);

  const hasOptions =
    data.isAdmin &&
    !data.isReadOnly &&
    Boolean(
      actions.handleViewEncumbrance ||
        actions.handleEditEncumbrance ||
        actions.handleRemoveEncumbrance
    );
  const columns = [
    { key: 'number', content: t('No.') },

    { key: 'shares', content: t('NrPart'), textPosition: 'right' },

    { key: 'type', content: t('Type') },

    { key: 'from', content: t('From'), textPosition: 'right' },

    { key: 'to', content: t('To'), textPosition: 'right' },

    { key: 'start-date', content: t('StartDate') },

    { key: 'end-date', content: t('EndDate') },

    { key: 'status', content: t('Status') },

    hasCoOwnersColumn ? { key: 'co-owners', content: t('CoOwners') } : null,

    hasOptions ? { key: 'actions', content: '' } : null,
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default EncumbrancesTableHeader;
